
export function toggleRedirectsFormModal() {
    return function (dispatch) {
        dispatch({type: 'TOGGLE-REDIRECTS-FORM-MODAL'});
    }
}